const NAVIGATE_URL = {
  QMAS_CREATE_JOB: `${process.env.REACT_APP_QMAS_URL}/inspection/jobs/new`,
  QMAS_DUPLICATE_JOB: (id: string) =>
    `${process.env.REACT_APP_QMAS_URL}/inspection/internal/${id}/duplicate`
};

export default NAVIGATE_URL;
